// Shared 400 `code` for signup email rejections (one code; don't leak why).
const SIGNUP_EMAIL_ERROR_CODES = ['EMAIL_NOT_ACCEPTED'] as const;

export type SignupEmailErrorCode = (typeof SIGNUP_EMAIL_ERROR_CODES)[number];

export const isSignupEmailErrorCode = (
  value: unknown
): value is SignupEmailErrorCode =>
  typeof value === 'string' &&
  (SIGNUP_EMAIL_ERROR_CODES as readonly string[]).includes(value);
